<template>
    <div>
        <div class="banner news-bn">
            <img src="@/assets/images/banner8.png" alt="">
            <h2 class="title">NEWS｜今天來點什嘛</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li>
                        <router-link :to="{name: 'news'}" class="tabs-item tabsFilter">
                            <div class="name">
                                大樓<br>公告
                            </div>
                            <p>Notice</p>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'news'}" class="tabs-item tabsFilter">
                            <div class="name">
                                所有<br>訊息
                            </div>
                            <p>All Message</p>
                        </router-link>
                    </li>
                </ul>
            </section>
            <section class="page-section section">
                <div class="row">
                    <div class="col col2">
                        <div class="gallery-slick">
                            <div class="gallery-main">
                                <div v-for="(img,idx) in images_url" :key="idx" :class="idx == 0 ? 'active' : ''" class="gallery-item" :style="{backgroundImage: 'url(' + img + ')' }"></div>
                            </div>
                            <div class="gallery-nav">
                                <a v-for="(img,idx) in images_url" :key="idx" :class="idx == 0 ? 'active' : ''" href="javascript:void(0);" class="gallery-item" :style="{backgroundImage: 'url(' + img + ')' }"></a>
                            </div>
                        </div>
                    </div>
                    <div class="col col2">
                        <div class="intro news-intro">
                            <h2>
                                {{ news_list.title }}
                                <div class="date">
                                    {{ news_list.enable_time }}
                                </div>
                            </h2>
                            {{ news_list.content }}
                        </div>
                    </div>
                </div>
                <div class="content">
                    <h3 class="title">
                        <span>其他訊息</span>
                    </h3>
                    <ul class="link-group">
                        <li v-for="other in news_other" :key="other.id">
                            <router-link :to="{path: `/newsPage/${other.id}`}">
                                <span class="date">
                                    {{ other.enable_time }}
                                </span>
                                <span class="name">
                                    {{ other.title }}
                                </span>
                                <span class="text">
                                    {{ other.content }}
                                </span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'newsPage',
    data () {
        return {
            news_list: '',
            images_url: [],
            news_other: []
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'NewsPage');
        formData.append('news_id', this.$route.params.id);
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('NewsPage: Server Error');
            } else {
                const get_list = response.data.news_list;
                const get_imgs = response.data.images_url;
                const get_other = response.data.news_other;
                this.news_list = get_list;
                this.images_url = JSON.parse(get_imgs);
                this.news_other = get_other;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    methods: {
        get_list (id) {
            const formData = new FormData();
            formData.append('CMD', 'NewsPage');
            formData.append('news_id', id);
            this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
            .then(response => {
                if (response.data.result == false) {
                    console.log('NewsPage: Server Error');
                } else {
                    const get_list = response.data.news_list;
                    const get_imgs = response.data.images_url;
                    const get_other = response.data.news_other;
                    this.news_list = get_list;
                    this.images_url = JSON.parse(get_imgs);
                    this.news_other = get_other;
                }
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    mounted: function() {
        var gallery = $('.gallery-slick');
        gallery.find(".gallery-nav").on("click", ".gallery-item", function (e) {
            e.preventDefault();
            var _idx = gallery.find(".gallery-nav .gallery-item").index($(this));
            $(this).addClass("active").siblings().removeClass("active");
            gallery.find(".gallery-main .gallery-item").eq(_idx).addClass("active").siblings().removeClass("active");
        });
    },
    watch: {
        $route (e) {
            const goto_page = e.params.id
            this.get_list (goto_page);
        }
    }
};
</script>

<style>

</style>
